<template>
    <div class="form-group input-password">
        <label :for="name">{{title}}</label>
        <input :type="show ? 'text' : 'password'" v-bind:class="error ? 'is-invalid' : ''" class="form-control clean-form" :id="name" @input="$emit('input',$event.target.value)">
        <div class="invalid-feedback" v-if="error">
            {{ error }}
        </div>
        <div class="action-button pointer" @click="show = !show" v-bind:class="error ? 'is-invalid' : ''">
            <i class="icon" v-bind:class="show ? 'icon-eye_visibility' : 'icon-eye_invisible'"></i>
        </div>
    </div>
</template>
<script>
export default {
    props: ['title', 'name', 'error'],
    data() {
        return {
            show: false,
        }
    }
}
</script>
<style scoped>
.form-group {
    text-align: center;
    position: relative;
}
.input-password .action-button {
    position: absolute;
    right: 8px;
    margin-top: -30px;
}
.action-button.pointer.is-invalid {
    display: none;
}
</style>
